module.exports = __webpack_public_path__ + "images/168f936b63dfb7242afb2d0c00f93a90.svg";